<template>
  <BootstrapModal class="EditSynonym"
                  v-on="$listeners"

                  @save="saveProductGroup"
  >
    <div>
      <FormInput
        class="form-element"
        v-model="$v.name.$model"

        id="name"
        label="Synoniem groepsnaam"

        :vuelidate="$v"
        fieldName="name"
      />
      <FormInput
        class="form-element"
        v-model="$v.synonyms.$model"

        id="synonyms"
        label="Synoniemen (gescheiden door komma's)"

        :vuelidate="$v"
        fieldName="synonyms"
      />
    </div>

    <template #title>
      {{ synonym ? "Synonym bewerken" : "Synonym toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["synonym", "callback"],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    name: { required },
    synonyms: { required },
  },
  data() {
    return {
      name: "",
      synonyms: "",
    }
  },
  created() {
    if (this.synonym) {
      this.$v.name.$model = this.synonym.name
      this.$v.synonyms.$model = this.synonym.synonyms.join(", ")
    }
  },
  methods: {
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
        synonyms: this.$v.synonyms.$model.replace(/,\s/g, ',').split(","),
      }

      this.$handlePromise(async () => {
        if (this.synonym) {
          await this.axios.put(`/api/synonyms/${this.synonym.uid}`, payload)
        } else {
          await this.axios.post(`/api/synonyms`, payload)
        }
        this.$store.dispatch('clearCacheSearch', "synonyms")

        this.$success("Synonym succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditSynonym {
  flex-basis: 500px;
}

</style>
